import { render, staticRenderFns } from "./WebsiteHeader.vue?vue&type=template&id=70811de0&scoped=true&"
import script from "./WebsiteHeader.vue?vue&type=script&lang=js&"
export * from "./WebsiteHeader.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteHeader.vue?vue&type=style&index=0&id=70811de0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70811de0",
  null
  
)

export default component.exports